import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok";

const Hero = ({ blok }) => {
  // console.log(blok)

  return (
    <div className="relative h-[250px]" {...storyblokEditable(blok)}>
      <img loading="lazy" src={blok.bgImage?.filename} alt={blok.bgImage.alt} className="absolute w-full h-[250px] object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-gray-950 to-transparent h-[250px]"></div>
      <div className="absolute inset-0 flex items-center justify-center h-[250px]">
        <h1 className="text-4xl text-white font-bold font-serif">{blok.subHeading}</h1>
        <h1 className="text-4xl text-white font-bold font-serif">{blok.heading}</h1>
      </div>
    </div>
  )
};

export default Hero;
